export enum RelationshipsTranslationKey {
    NAME = "relationships.name",
    RELATIONSHIP_DETAIL = "relationships.relationshipDetail",
    SOURCE = "relationships.source",
    TARGET = "relationships.target",
    TYPE = "relationships.type",
}